import { InjectionToken } from '@angular/core';

export interface CbCoreEnvironment {
  production: boolean;
  sentryUrl?: string;
  sentryShowDialog?: boolean;
  includeLegs?: boolean;
  allEndpointsWithCredentials?: boolean;
  appVersion?: string;
  core?: {
    trackingPageTitle?: string;
    customSessionExpireRedirect?: boolean;
  };
}

export const CB_CORE_ENV = new InjectionToken<CbCoreEnvironment>('CB_CORE_ENV');
